import { createSlice } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../../constants/fetchStatuses';
import {
  fetchCompanyDepartments,
  createCompanyDepartment,
  fetchCompanyDepartment,
  updateCompanyDepartment,
  deleteCompanyDepartment,
  restoreCompanyDepartment,
} from './companyDepartments.actions';
import { CompanyDepartmentsState } from './companyDepartments.types';

const initialState: CompanyDepartmentsState = {
  companyDepartments: [],
  totalCompanyDepartments: 0,
  selectedCompanyDepartment: null,
  fetchCompanyDepartmentsStatus: fetchStatuses.idle,
  fetchCompanyDepartmentStatus: fetchStatuses.idle,
  createCompanyDepartmentStatus: fetchStatuses.idle,
  updateCompanyDepartmentStatus: fetchStatuses.idle,
  deleteCompanyDepartmentStatus: fetchStatuses.idle,
  restoreCompanyDepartmentStatus: fetchStatuses.idle,
  error: null,
};

const companyDepartmentsSlice = createSlice({
  name: 'companyDepartments',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // === FETCH COMPANY DEPARTMENTS ===
    builder.addCase(fetchCompanyDepartments.pending, (state) => {
      state.error = null;
      state.fetchCompanyDepartmentsStatus = fetchStatuses.pending;
    });
    builder.addCase(fetchCompanyDepartments.fulfilled, (state, action) => {
      state.fetchCompanyDepartmentsStatus = fetchStatuses.success;
      state.companyDepartments = action.payload.data?.data ?? [];
      state.totalCompanyDepartments = action.payload.data?.total ?? 0;
    });
    builder.addCase(fetchCompanyDepartments.rejected, (state, action) => {
      state.fetchCompanyDepartmentsStatus = fetchStatuses.rejected;
      state.error = action.error;
    });

    // === FETCH SINGLE COMPANY DEPARTMENT ===
    builder.addCase(fetchCompanyDepartment.pending, (state) => {
      state.error = null;
      state.fetchCompanyDepartmentStatus = fetchStatuses.pending;
    });
    builder.addCase(fetchCompanyDepartment.fulfilled, (state, action) => {
      state.fetchCompanyDepartmentStatus = fetchStatuses.success;
      state.selectedCompanyDepartment = action.payload.data ?? null;
    });
    builder.addCase(fetchCompanyDepartment.rejected, (state, action) => {
      state.fetchCompanyDepartmentStatus = fetchStatuses.rejected;
      state.error = action.error;
    });

    // === CREATE COMPANY DEPARTMENT ===
    builder.addCase(createCompanyDepartment.pending, (state) => {
      state.error = null;
      state.createCompanyDepartmentStatus = fetchStatuses.pending;
    });
    builder.addCase(createCompanyDepartment.fulfilled, (state) => {
      state.createCompanyDepartmentStatus = fetchStatuses.success;
    });
    builder.addCase(createCompanyDepartment.rejected, (state, action) => {
      state.createCompanyDepartmentStatus = fetchStatuses.rejected;
      state.error = action.error;
    });

    // === UPDATE COMPANY DEPARTMENT ===
    builder.addCase(updateCompanyDepartment.pending, (state) => {
      state.error = null;
      state.updateCompanyDepartmentStatus = fetchStatuses.pending;
    });
    builder.addCase(updateCompanyDepartment.fulfilled, (state) => {
      state.updateCompanyDepartmentStatus = fetchStatuses.success;
    });
    builder.addCase(updateCompanyDepartment.rejected, (state, action) => {
      state.updateCompanyDepartmentStatus = fetchStatuses.rejected;
      state.error = action.error;
    });

    // === DELETE COMPANY DEPARTMENT ===
    builder.addCase(deleteCompanyDepartment.pending, (state) => {
      state.error = null;
      state.deleteCompanyDepartmentStatus = fetchStatuses.pending;
    });
    builder.addCase(deleteCompanyDepartment.fulfilled, (state) => {
      state.deleteCompanyDepartmentStatus = fetchStatuses.success;
    });
    builder.addCase(deleteCompanyDepartment.rejected, (state, action) => {
      state.deleteCompanyDepartmentStatus = fetchStatuses.rejected;
      state.error = action.error;
    });

    // === RESTORE COMPANY DEPARTMENT ===
    builder.addCase(restoreCompanyDepartment.pending, (state) => {
      state.error = null;
      state.restoreCompanyDepartmentStatus = fetchStatuses.pending;
    });
    builder.addCase(restoreCompanyDepartment.fulfilled, (state) => {
      state.restoreCompanyDepartmentStatus = fetchStatuses.success;
    });
    builder.addCase(restoreCompanyDepartment.rejected, (state, action) => {
      state.restoreCompanyDepartmentStatus = fetchStatuses.rejected;
      state.error = action.error;
    });
  },
});

export const companyDepartmentsyReducer = companyDepartmentsSlice.reducer;
